import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    nextButtonLabel: 'Next',
    noResponse: 'No, I’m an EI/EIRL',
    title: 'Is your company a micro-entreprise?',
    yesResponse: 'Yes, I’m a micro-entrepreneur',
  },
  fr: {
    nextButtonLabel: 'Continuer',
    noResponse: 'Non, j’ai une EI / EIRL',
    title: 'Est-ce que votre entreprise est une micro-entreprise\u00A0?',
    yesResponse: 'Oui, je suis micro-entrepreneur',
  },
});
